import z from "zod";

const subscriptionPaymentSchema = z.object({
  id: z.string(),
  amount: z.string(),
  card_type: z.string().nullable(),
  date: z.string(),
  description: z.string(),
  last_four: z.string().nullable(),
  payment_gateway: z.enum(["braintree", "crypto_dot_com"]),
  payment_method_display: z.string().nullable(),
  status: z.enum(["paid", "failed", "pending", "unknown"]),
  tax_amount: z.string().nullable(),
  total_amount: z.string(),
});

type SubscriptionPayment = z.infer<typeof subscriptionPaymentSchema>;

export { subscriptionPaymentSchema, type SubscriptionPayment };
